import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { AdminBillingPage } from "@/features/billing";
import { requireSubscriptionManagement } from "@/lib/subscription-management";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/accounts/$projectId",
)({
  beforeLoad: async ({ context }) => {
    requireSuperAdmin(context);
    await requireSubscriptionManagement();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return <AdminBillingPage projectId={projectId} />;
}
